import { useRouter } from 'next/router';
import { useState } from 'react';

import appState from 'hooks/appState';
import { APP_STATE } from 'types';
import SocialActivityAction from 'components/SocialActivityAction';
import PostHeader from 'components/PostHeader';
import ImageSlider from 'containers/ImageSlider';
import CollaboratorsSlider from 'containers/CollaboratorsSlider';
import { likePost, unlikePost } from 'services/likePost';
import SocialActivity from 'components/SocialActivity';
import useSingleAndDoubleClick from 'hooks/useSingleAndDoubleClick';
import { routesPath } from 'utils/constants/routePath';
import { IProfileVehiclePost } from './IProfileVehiclePost';

import {
  CarInfoBlock,
  CoverImg,
  ProfileVehiclePostWrapper,
  MediaWrapper,
  SocialActivityBlock,
  WheelMarkIconWrap,
} from './ProfileVehiclePost.styles';

const ProfileVehiclePost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  make,
  model,
  year,
  isMe,
  followingStatus,
  postTime,
  mediaObjects = [],
  nickname,
  origin,
  isLike,
  likes,
  variant,
  id,
  isEventLikes,
  originId,
  commentsCount,
  sharesCount,
  collaborators,
  data,
  onCommentClick,
  isAdmin
}: IProfileVehiclePost) => {
  const [postLike, setPostLike] = useState<boolean>(isLike);
  const [likesCount, setLikesCount] = useState<number>(likes || 0);

  const [isProfileVehicleUrlCopied, setIsProfileVehicleUrlCopied] =
    useState<boolean>(false);

  const appStateAction = appState();
  const router = useRouter();

  const onLikePost = (id) => {
    setPostLike(!postLike);
    if (postLike) {
      unlikePost(id).then((res) => {});
      setLikesCount(likesCount - 1);
      return;
    }
    likePost(id).then((res) => {
      // console.log(res)
    });
    setLikesCount(likesCount + 1);
  };

  const handleOnPhoto = useSingleAndDoubleClick(
    () => {
      // appStateAction(APP_STATE.EXPAND_IMAGES_TOGGLE, {
      //   isOpen: true,
      //   data,
      // });
      router.push(`${routesPath.vehicle_details}/${originId}`);
    },
    () => {
      onLikePost(id);
    }
  );
  return (
    <ProfileVehiclePostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={4}
        make={make}
        model={model}
        year={year}
        id={id}
        origin={origin}
        originId={originId}
        data={data}
        isAdmin={isAdmin}
      />

      <MediaWrapper>
        <div onClick={handleOnPhoto}>
          <ImageSlider images={mediaObjects} />
        </div>
        <CarInfoBlock>
          <div>{`${make && make} ${model && model} ${year && year}`}</div>
          {nickname && <span>{nickname}</span>}
        </CarInfoBlock>
      </MediaWrapper>
      <SocialActivityBlock>
        <SocialActivity
          id={id}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={(id) => onLikePost(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likesCount}
          isLike={postLike}
          postType={4}
          type="post"
          isUrlCopied={isProfileVehicleUrlCopied}
          setIsUrlCopied={setIsProfileVehicleUrlCopied}
        />
      </SocialActivityBlock>
      {collaborators?.length > 0 && (
        <CollaboratorsSlider collaborators={collaborators} />
      )}
    </ProfileVehiclePostWrapper>
  );
};

export default ProfileVehiclePost;
